// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"487":"3e85e124","990":"69c1c7d4"}[chunkId] + ".chunk.css";
};